import React from "react";
import { Elements } from '@stripe/react-stripe-js';
import Paper from '@mui/material/Paper';
import StripeCardElement from "./StripeCardElement";
import { StripeClient } from "@utils/stripePayments";
import { logger } from "@services/workers/helpers";

const namespace = "STRIPE Payment"

type Props = {}

export const stripeClient = StripeClient() // create instance of StripeAPI

const StripeForm: React.FC<Props> = () => {
    const [stripeLoaded, setStripeLoaded] = React.useState(false)
    const [error, setError] = React.useState(null);

    // run on mount
    React.useEffect(() => {
        const abortController = new AbortController();
        stripeClient.getStripe(abortController).then((stripe) => {
            if (stripe) {
                setStripeLoaded(true)
                stripeClient.setError = setError
            }
        })
        return () => {
            abortController.abort()
        }
    }, [])

    // errors logging
    React.useEffect(() => { if (error) logger.error(namespace + "->" + React.useEffect.name, "ERROR:", error as any) }, [error])

    return (
        <Paper elevation={4} sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(1),
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                padding: theme.spacing(1),
            },
        })}>
            {stripeLoaded && (<Elements stripe={stripeClient.stripe} >
                <StripeCardElement />
            </Elements>)
            }
        </Paper>
    );
}

export default StripeForm